import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { OverlayMapComponent } from '@propmix/overlay-map';
import { NoContentBannerComponent } from 'src/app/shared/components/no-content-banner/no-content-banner.component';
import { EnumRefPipe } from 'src/app/shared/pipes/enum-ref.pipe';
import { EmptyDataPipe } from '../../../../shared/pipes/empty-data.pipe';
import { SimpleDatePipe } from '../../../../shared/pipes/simple-date.pipe';
import { UnitAffixPipe } from '../../../../shared/pipes/unitAffix.pipe';
import { BathroomDecimalPipe } from '../../../property/pipe/bathroom-decimal.pipe';
import { SearchedProperty } from '../../interface/new-order.interface';

@Component({
  selector: 'app-property-description',
  standalone: true,
  imports: [
    CommonModule,
    NoContentBannerComponent,
    OverlayMapComponent,
    EmptyDataPipe,
    SimpleDatePipe,
    UnitAffixPipe,
    MatButtonModule,
    EnumRefPipe,
    BathroomDecimalPipe,
  ],
  templateUrl: './property-description.component.html',
  styleUrl: './property-description.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyDescriptionComponent {
  parseFloat = parseFloat;

  @Input({ required: true }) property!: SearchedProperty;

  constructor() {}

  ngOnInit() {}
}
